var map = {
	"./WhatsApp Image 2025-05-29 at 2.54.42 PM.jpeg": 25281,
	"./WhatsApp Image 2025-05-29 at 2.54.43 PM (1).jpeg": 28030,
	"./WhatsApp Image 2025-05-29 at 2.54.43 PM (2).jpeg": 8489,
	"./WhatsApp Image 2025-05-29 at 2.54.43 PM.jpeg": 25572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58787;